import {createTheme} from '@mui/material'
import {lighten} from '@mui/system/colorManipulator'
import {APP_BACKGROUND, CARD_BORDER_COLOR, CARD_BORDER_RADIUS, NEUTRAL_SCALE, SEMANTIC} from './tokens'

const FALLBACK_PRIMARY = '#5BA77E'

export function buildThemeNew(pspTheme: Record<string, any>) {
  const primaryColor = pspTheme.primaryColor || FALLBACK_PRIMARY
  const hoverbutton = pspTheme.hoverbutton || primaryColor
  const secondaryColor = pspTheme.secondaryColor || primaryColor
  const darkerColor = pspTheme.darkerColor || NEUTRAL_SCALE[900]

  return createTheme({
    palette: {
      darkerColor: {main: darkerColor},
      primary: {
        main: primaryColor,
        dark: hoverbutton,
        light: lighten(primaryColor, 0.7),
      },
      secondary: {
        main: secondaryColor,
      },
      success: {
        main: SEMANTIC.success.main,
        light: SEMANTIC.success.light,
        dark: SEMANTIC.success.dark,
      },
      warning: {
        main: SEMANTIC.warning.main,
        light: SEMANTIC.warning.light,
        dark: SEMANTIC.warning.dark,
      },
      error: {
        main: SEMANTIC.error.main,
        light: SEMANTIC.error.light,
        dark: SEMANTIC.error.dark,
      },
      info: {
        main: SEMANTIC.info.main,
        light: SEMANTIC.info.light,
        dark: SEMANTIC.info.dark,
      },
      neutral: {
        main: NEUTRAL_SCALE[500],
        900: NEUTRAL_SCALE[900],
        700: NEUTRAL_SCALE[700],
        500: NEUTRAL_SCALE[500],
        300: NEUTRAL_SCALE[300],
        200: NEUTRAL_SCALE[200],
        100: NEUTRAL_SCALE[100],
        50: NEUTRAL_SCALE[50],
      },
      background: {
        default: APP_BACKGROUND,
      },
    },
    typography: {
      fontFamily: 'Inter, system-ui, -apple-system, Roboto, sans-serif',
      h1: {fontSize: 20, fontWeight: 700, fontFamily: "'Helvetica Neue', Helvetica, Arial, sans-serif", letterSpacing: '0.15px'},
      h2: {fontSize: 20, fontWeight: 700, fontFamily: "'Helvetica Neue', Helvetica, Arial, sans-serif", letterSpacing: '0.15px'},
      h3: {fontSize: 16, fontWeight: 600, fontFamily: "'Helvetica Neue', Helvetica, Arial, sans-serif"},
      body1: {fontSize: 14, fontWeight: 400},
      body2: {fontSize: 14, fontWeight: 400},
      caption: {fontSize: 12, fontWeight: 400},
    },
    shape: {
      borderRadius: 8,
    },
    spacing: 8,
    components: {
      MuiCard: {
        defaultProps: {
          variant: 'outlined',
        },
        styleOverrides: {
          root: {
            borderRadius: CARD_BORDER_RADIUS,
            borderColor: CARD_BORDER_COLOR,
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: 'none',
          },
        },
      },
      MuiTab: {
        styleOverrides: {
          root: {
            textTransform: 'none',
          },
        },
      },
      MuiTabs: {
        styleOverrides: {
          indicator: ({theme}) => ({
            backgroundColor: theme.palette.primary.main,
          }),
        },
      },
      MuiChip: {
        styleOverrides: {
          root: {
            borderRadius: 9999,
          },
        },
      },
    },
  })
}
